module.exports = __webpack_public_path__ + "static/media/settings_gear_icon_active.2dd8f1ab.svg";